import { render } from "./JsonPreview.vue?vue&type=template&id=513fb29d"
import script from "./JsonPreview.vue?vue&type=script&lang=js"
export * from "./JsonPreview.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__